import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DEFAULT_LANG, isLang, normalizeLang } from "./types";

export const LANG_STORAGE_KEY = "optify_lang";

/**
 * On the bare default-language home ("/"), redirect real users to their browser
 * language (or a stored preference). Crawlers / the prerenderer are skipped via
 * navigator.webdriver, so "/" stays the canonical Romanian page for indexing.
 */
export function RootLanguageRedirect() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname !== "/") return;
    if (typeof navigator !== "undefined" && navigator.webdriver) return;

    let target = DEFAULT_LANG;
    const stored = typeof localStorage !== "undefined" ? localStorage.getItem(LANG_STORAGE_KEY) : null;

    if (stored && isLang(stored)) {
      target = stored;
    } else {
      const candidates = navigator.languages?.length ? navigator.languages : [navigator.language];
      for (const c of candidates) {
        const n = normalizeLang(c);
        if (n) {
          target = n;
          break;
        }
      }
    }

    if (target !== DEFAULT_LANG) {
      navigate(`/${target}`, { replace: true });
    }
  }, [pathname, navigate]);

  return null;
}
